import { render, staticRenderFns } from "./form-desc.vue?vue&type=template&id=7b130cfe&"
import script from "./form-desc.vue?vue&type=script&lang=js&"
export * from "./form-desc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports